import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function SessionExpiredModal() {
  const { sessionExpired, dismissSessionExpired } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();

  if (!sessionExpired) return null;

  const t = language === 'fr' ? {
    title: "Session expirée",
    body: "Votre session a expiré après 30 minutes d'inactivité pour protéger votre compte. Veuillez vous reconnecter pour continuer.",
    cta: "Se reconnecter",
  } : {
    title: "Session expired",
    body: "Your session has expired after 30 minutes of inactivity to protect your account. Please sign in again to continue.",
    cta: "Sign in again",
  };

  const handleSignIn = () => {
    dismissSessionExpired();
    navigate('/login');
  };

  return (
    <div
      data-testid="session-expired-modal"
      className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center animate-in fade-in zoom-in duration-200">
        <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-5">
          <Clock className="w-8 h-8 text-amber-600" />
        </div>
        <h2 className="text-2xl font-extrabold text-[#1D1D1D] mb-2">{t.title}</h2>
        <p className="text-gray-600 text-sm leading-relaxed mb-6">{t.body}</p>
        <button
          data-testid="session-expired-signin-btn"
          onClick={handleSignIn}
          className="w-full bg-[#CD0000] hover:bg-[#A00000] text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-colors"
        >
          <LogIn className="w-4 h-4" /> {t.cta}
        </button>
      </div>
    </div>
  );
}
